<template>
  <div
    id="commentModal"
    aria-labelledby="commentModalLabel"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            ref="close"
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
            @click="onResetForm"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            id="commentModalLabel"
            class="modal-title"
          >
            {{ $t('string.last10Comment') }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <template v-if="isLoading">
                <div class="loading-comments">
                  <p class="text-center text-muted">
                    {{ $t('string.isLoading') }}
                  </p>
                </div>
              </template>
              <template v-else>
                <template v-if="Array.isArray(comments) && comments.length">
                  <div class="comments">
                    <template v-for="(item, key) in comments">
                      <comment-item
                        :key="key"
                        :item="item"
                      />
                    </template>
                  </div>
                  <template v-if="can([$Permissions.backend.comment.list])">
                    <button
                      class="btn btn-default btn-sm mt-3"
                      @click="viewAllComments"
                    >
                      {{ $t('string.viewAllComments') }}
                    </button>
                  </template>
                </template>
                <div
                  v-else
                  class="empty-comments"
                >
                  <p class="text-center text-muted">
                    {{ $t('string.emptyComments') }}
                  </p>
                </div>
              </template>
            </div>
          </div>

          <div
            class="box box-warning"
            style="box-shadow: none; margin-top: 1rem; !important;"
          >
            <div class="box-body">
              <div>
                <x-textarea
                  v-model="comment"
                  :label="$t('string.comment')"
                  :placeholder="$t('placeholder.comment')"
                  :required="true"
                  :rows="2"
                  :validations="validations"
                  name="comment"
                />
              </div>
              <div class="form-group">
                <button
                  :disabled="isSaveWaiting"
                  class="btn btn-primary btn-sm margin-right-5"
                  type="button"
                  @click="onSave"
                >
                  <i
                    v-if="isSaveWaiting"
                    class="fa fa-spinner fa-spin"
                  /> {{ $t('string.addComment') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommentItem from '@/views/comments/components/CommentItem'

export default {
  name: 'CommentModal',
  components: { CommentItem },
  props: {
    routeViewAllComments: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      comments: [],
      validations: {},
      comment: '',
      isLoading: false,
      isSaveWaiting: false
    }
  },
  computed: {
    ...mapState({
      borrow_id: state => state.comment.borrow_id,
      refreshCommentList: state => state.comment.refreshCommentList,
      open_comment_modal: state => state.comment.open_comment_modal
    })
  },
  watch: {
    open_comment_modal () {
      if (this.borrow_id) {
        this.getCommentList()
      }
    },
    refreshCommentList () {
      this.getCommentList()
    }
  },
  methods: {
    viewAllComments () {
      this.$refs.close.click()
      return this.$router.push(this.routeViewAllComments)
    },
    onResetForm () {
      this.comment = ''
      this.validations = {}
      this.$refs.close.click()
    },
    onSave () {
      this.validations = {}
      this.isSaveWaiting = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/comment/create', {
        borrow_id: this.borrow_id,
        comment: this.comment
      }).then(({ data }) => {
        if (data.data) {
          this.getCommentList()
          this.comment = ''
          this.$store.commit('comment/setRefreshCommentList')
          this.onResponseSuccess()
        }
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        } else {
          this.onResponseError(error)
        }
      }).finally(() => {
        this.isSaveWaiting = false
      })
    },
    getCommentList () {
      this.isLoading = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/comment/last-comment-list', {
        borrow_id: this.borrow_id
      }).then(({ data }) => {
        if (data.data) {
          this.comments = data.data
        } else {
          this.comments = []
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
